import { Modal, Card } from "@mui/material";
import "../css/Override.scss";
import { useNavigate } from "react-router-dom";
import "./SaveCompareId.scss";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import GameService from "../../service/GameService";

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  compid: string;
};

const SaveCompareId = ({ open, handleClose, compid }: ModalProp) => {
  const { t } = useTranslation();
  // const [compUrl, setCompUrl] = useState("");
  const url = window.location.href;
  console.log(compid);
  var host = url.split("?");
  const compUrl = host[0] + "?cmpid=" + compid;

  useEffect(() => {
    var host = url.split("?");
    // setCompUrl(host[0] + "?compid=" + compid);
  }, []);

  const closeModal = () => {
    handleClose();
  };

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      alert("failed");
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="compare-modal-main"
      >
        <div className="compare-modal-content">
          <button className="closebutton" onClick={closeModal} />
          <div className="modal-copy-compare-wrap">
            <div className="modal-copy-compare-id-title">{t("compare-title")}</div>
            <div className="modal-copy-compare-id-url">{compUrl}</div>
            <button onClick={() => handleCopyClipBoard(compUrl)}>{t("copytoclip")}</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SaveCompareId;
